import React from "react";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import {
  SearchBranchListing,
  SearchProfileListing,
  SearchTab,
} from "./widget/SearchWidgets";
import Div from "../../widget/common/ui/Div";
import SearchInput from "../../widget/common/form/SearchInput";
import { SearchContextImport } from "../../provider/search/SearchContextProvider";

const SearchContent = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const { tabId, handleOnChange, clearSearch, searchValue } =
    SearchContextImport();

  return (
    <Div>
      <SearchInput
        name="search-branch"
        placeHolder="search"
        handleOnChange={handleOnChange}
        onClickSuffix={clearSearch}
        value={searchValue}
        autoFocus={true}
      />
      <SearchTab type={type} />

      <Div className="py-4 pb-5">
        {tabId === "1" ? <SearchBranchListing /> : <SearchProfileListing />}
      </Div>
    </Div>
  );
};

export default SearchContent;
